<template>
    <div class="menus">
        <template v-for="menu in routes">
            <div
                v-show="!menu.hidden"
                class="menu-item"
                :class="{ actived: menu.path && selectedPath === menu.path, disabled: !menu.path }"
                :key="menu.path"
                @click="routeTo(menu)"
            >
                {{ menu.name }}

                <div class="second-menu" v-if="menu.path === '/driverDownload'">
                    <div class="driver-content">
                        <div class="driver-text">KM202MGD、KM218MGD</div>
                        <div class="driver-btn"
                             @click="openNew('https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/qdxz/202MGDPDDCloudPrinter_V1.0.5.1_Build20250305213001_Final.exe')">
                            立即下载
                            <img src="./images/download.png" alt=""/>
                        </div>
                        <div class="driver-hr"></div>
                        <div class="driver-text">其它型号</div>
                        <div class="driver-btn" style="width: 97rem;" @click="openNew('https://dyj.kuaimai.com/#/device')">
                            点击跳转下载
                            <img src="./images/download.png" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import {routes} from "../../router";

export default {
    name: "Menus",
    data() {
        return {
            routes: routes,
            selectedPath: "",
        };
    },
    mounted() {
        this.selectedPath = this.$route.path;
        this.$router.afterEach((to) => {
            this.selectedPath = to.path;
        });
    },
    methods: {
        routeTo(route) {
            if (route.externalUrl) {
                window.open(route.externalUrl);
                return;
            }
            if (route.router === 'none') {
                return;
            }
            let path = route.path;
            if (!path || path === this.selectedPath) {
                return;
            }
            this.$router.push(path);
            this.selectedPath = path;
        },
        openNew(url) {
            window.open(url);
        },
    },
};
</script>

<style lang="scss" scoped>
.menus {
    display: flex;
    flex-direction: row;

    .menu-item {
        position: relative;
        font-size: 18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        cursor: pointer;
        transition: all 0.3s;

        &.actived {
            color: #FD6520;
            transition: all 0.3s;
        }

        &.disabled {
            cursor: not-allowed;
            color: #cccccc;
        }

        &:hover {
            color: #FD6520;
            transition: all 0.3s;

            .second-menu {
                display: block;
            }
        }

        &:not(:last-child) {
            margin-right: 32rem;
        }

        .second-menu {
            padding: 16rem;
            display: none;
            position: absolute;
            transform: translate3d(-50%, 12rem, 0);
            background: #FAFAFA;
            box-shadow: 0 -2rem 10rem 0 rgba(25, 26, 56, 0.52);
            border-radius: 13rem;

            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: -20rem;
                width: 100%;
                height: 20rem;
            }

            .driver-content {
                display: flex;
                flex-direction: column;

                .driver-text {
                    margin: 12rem 0;
                    width: 124px;
                    height: 10px;
                    font-family: OPPOSans;
                    font-weight: 400;
                    font-size: 10px;
                    color: #1A1939;
                    white-space: nowrap;
                }

                .driver-btn {
                    margin-bottom: 10rem;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    width: 74rem;
                    height: 22rem;
                    gap: 5rem;
                    padding: 8rem;
                    background: #FC6521;
                    border-radius: 5rem;
                    font-family: OPPOSans;
                    font-weight: 400;
                    font-size: 10rem;
                    color: #FFFFFF;

                    img {
                        width: 13rem;
                        height: 13rem;
                    }
                }

                .driver-hr {
                    border-bottom: 1px dashed #1A1939;
                }
            }
        }
    }
}
</style>
